import { MapPin, Plus } from '@spcc/uikit'
import { TableEmptyState } from '@spcc/uikit'
import type { AddressbookEmptyStateProps } from '../types'

export function AddressbookEmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: AddressbookEmptyStateProps) {
  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      <TableEmptyState
        icon={MapPin}
        title={title}
        description={description}
        actionLabel={actionLabel}
        actionIcon={Plus}
        onAction={onAction}
      />
    </div>
  )
}
